import { useTranslation } from 'react-i18next';
import { z } from 'zod';

const directionTipRegex = /^[\p{L}\p{N}\p{So}\p{Sk}\s.,!?()_*-]+$/u;

export const useUpdateDestinationDirectionTipsDialogValidationSchema = () => {
  const { t } = useTranslation(['validation']);

  return z
    .object({
      directionTips: z
        .array(
          z
            .object({
              pl: z
                .string()
                .refine(val => !val || val.length <= 255, {
                  message: t('maxCharacters', { count: 255 }),
                })
                .refine(val => !val || directionTipRegex.test(val), {
                  message: t('invalidFormat'),
                }),
              en: z
                .string()
                .refine(val => !val || val.length <= 255, {
                  message: t('maxCharacters', { count: 255 }),
                })
                .refine(val => !val || directionTipRegex.test(val), {
                  message: t('invalidFormat'),
                }),
              ua: z
                .string()
                .refine(val => !val || val.length <= 255, {
                  message: t('maxCharacters', { count: 255 }),
                })
                .refine(val => !val || directionTipRegex.test(val), {
                  message: t('invalidFormat'),
                }),
            })
            .strict(),
        )
        .max(
          50,
          t('maxNumber', {
            number: 50,
          }),
        ),
    })
    .strict();
};
